import { CustomModal } from "@/components/custom-modal";
import { Button } from "@/components/ui/button";

import {
    DialogClose,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Separator } from "@/components/ui/separator";
import { BookText, ChevronLeft, ChevronRight, Loader2 } from "lucide-react";

import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";

import { Checkbox } from "@/components/ui/checkbox";

import { CopyIcon } from "@/assets";
import { InputOTP, InputOTPSlot } from "@/components/ui/input-otp";
import { useAuthState } from "@/context";
import { ToastMessage, type } from "@/lib/toastr";
import { useCopy } from "@/lib/useCopyToClipBoard";
import {
    getAccountName,
    getAllBank,
    getCryptoPayInAddress,
    getFiatPayIn,
} from "@/services/Home.service";
import {
    createTransaction,
    updateTransaction,
} from "@/services/Transactions.service";
import { getUserByName } from "@/services/Users.service";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
    Form,
    FormControl,
    FormDescription,
    FormField,
    FormItem,
    FormLabel,
} from "@/components/ui/form";
import { useForm } from "react-hook-form";

const UpdateTransaction = ({ data }: any) => {
    const queryClient = useQueryClient();

    const [open, setOpen] = useState(false);
    const [twoFa, setTwoFA] = useState("");
    const [amount, setAmount] = useState(Number);
    const [rate, setRate] = useState(Number);
    const [reference, setReference] = useState("");
    // const [twoFa, setTwoFA] = useState("");
    const [step, setStep] = useState(1);

    const mutation = useMutation({
        mutationFn: async (payload: unknown) =>
            await updateTransaction(data?.id, payload),
        mutationKey: ["transaction-update"],
        onSuccess: (res) => {
            console.log(res.data);
            queryClient.invalidateQueries({ queryKey: ["transactions"] });
            setOpen(false);
            ToastMessage(type.SUCCESS, "Transaction settlement completed successfully");
        },
        onError: (err: any) => {
            ToastMessage(type.ERROR, err.response.data.message);
        },
    });

    const form = useForm();

    const onSubmit = async () => {

        const payload = {
            twoFactorAuthenticationCode: twoFa,
            amountSettled: amount,
            reference: reference,
            rate: rate,
        };
        console.log(payload);
        await mutation.mutate(payload);
    };
    console.log(data?.beneficiary?.details?.accountName);
    console.log(data);
    return (
        <CustomModal
            button={
                <Button
                    variant="link"
                    className="flex items-center gap-2 text-xs text-primary-9 h-fit w-fit px-2 py-1.5  font-normal hover:no-underline"
                    // className="flex items-center gap-2 text-xs text-primary-9 h-fit w-fit px-2 py-1.5 font-normal hover:no-underline"
                    // onClick={() => mutationComplete.mutate()}
                    // onClick={() => setIsOpenUpdate(true)}
                    onClick={() => {
                        // console.log("object")

                        setOpen(true);
                    }}
                >
                    <BookText />
                    Update Transaction
                </Button>
            }
            size="md"
            open={open}
            onOpenChange={(e: any) => {
                setOpen(e);
                setStep(1);
                form.reset();
            }}
        // onOpenChange={(e) => {
        //     if (!e) handleClose();
        // }}
        >
            {/* <Form {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)}> */}
            <div className="flex flex-col gap-8">
                <DialogHeader className="bg-off-white-1 py-6 px-8 rounded-t-[16px]">
                    <DialogTitle className="text-sm font-normal capitalize text-primary-3">
                        Update Transaction
                    </DialogTitle>
                </DialogHeader>

                <div
                    className={cn(
                        "flex flex-col gap-7 px-8 pb-8"
                        // step === 2 || step === 4 ? "h-fit" : "h-[350px] overflow-auto"
                    )}
                >
                    {step === 1 ? (
                        <>
                            <div className="flex items-start gap-4 w-full justify-between">
                                <div className="w-full h-fit">
                                    <p className="text-gray-70 text-sm font-medium">
                                        Amount Deposited
                                    </p>
                                    <p className="text-gray-dark text-sm">
                                        {data?.amount} {data?.currency}
                                    </p>
                                </div>
                                <div className="w-full">
                                    <p className="text-gray-70 text-sm font-medium">
                                        Customer
                                    </p>
                                    <p className="text-gray-dark text-sm text-wrap">
                                        {data?.beneficiary?.details?.accountName}
                                    </p>
                                </div>
                            </div>

                            <div className="flex flex-col w-full items-start gap-1 border-[1px] rounded-[8px] px-2 py-2 h-[52px] border-input-border-2">
                                <Label htmlFor="role" className="text-xs">
                                    Rate
                                </Label>

                                <Input
                                    className="p-0 border-none bg-transparent rounded-none h-6 w-full "
                                    placeholder="Enter rate"
                                    type="number"
                                    onChange={e => setRate(Number(e.target.value))}

                                />
                            </div>


                            <div className="flex flex-col w-full items-start gap-1 border-[1px] rounded-[8px] px-2 py-2 h-[52px] border-input-border-2">
                                <Label htmlFor="role" className="text-xs">
                                    Amount Paid
                                </Label>

                                <Input
                                    className="p-0 border-none bg-transparent rounded-none h-6 w-full "
                                    placeholder="Enter amount"
                                    type="number"
                                    onChange={e => setAmount(Number(e.target.value))}

                                />
                            </div>


                            <div className="flex flex-col w-full items-start gap-1 border-[1px] rounded-[8px] px-2 py-2 h-[52px] border-input-border-2">
                                <Label htmlFor="role" className="text-xs">
                                    Withdrawal Reference
                                </Label>

                                <Input
                                    className="p-0 border-none bg-transparent rounded-none h-6 w-full "
                                    placeholder="Enter withdrawal reference"
                                    type="text"
                                    onChange={e => setReference(e.target.value)}

                                />
                            </div>

                        </>
                    ) : (
                        <div>
                            <InputOTP
                                maxLength={6}
                                onChange={(e) => setTwoFA(e)}
                                className="flex justify-between gap-8"
                            >
                                <InputOTPSlot index={0} className=" w-14 h-14" />
                                <InputOTPSlot index={1} className=" w-14 h-14" />
                                <InputOTPSlot index={2} className="w-14 h-14" />
                                <InputOTPSlot index={3} className=" w-14 h-14" />
                                <InputOTPSlot index={4} className=" w-14 h-14" />
                                <InputOTPSlot index={5} className="w-14 h-14" />
                            </InputOTP>
                        </div>
                    )}
                </div>
            </div>

            {/* </form>
            </Form> */}
            <DialogFooter className="px-6 py-4 flex flex-row justify-between items-center bg-off-white-1 rounded-b-[16px]">
                <DialogClose asChild>
                    <Button
                        type="button"
                        variant="ghost"
                        className=" text-primary0 h-12 rounded-[10px] p-[8px 12px] hover:text-primary0"
                    >
                        <ChevronLeft /> Cancel
                    </Button>
                </DialogClose>
                {step === 1 ? (
                    <Button
                        // type="button"
                        className="bg-gradient-to-r from-primary to-primary-2 h-12 rounded-[10px] p-[8px 12px]"
                        onClick={() => setStep(2)}
                    >
                        Save Changes
                    </Button>
                ) : (
                    <Button
                        // type="submit"
                        className="bg-gradient-to-r from-primary to-primary-2 h-12 rounded-[10px] p-[8px 12px]"
                        disabled={mutation.isPending}
                        onClick={onSubmit}
                    //  !form.formState.isDirty ||
                    //   !form.formState.isValid ||
                    //   form.formState.isSubmitting ||
                    >
                        {mutation.isPending && (
                            <Loader2 className="text-white animate-spin" />
                        )}
                        Confirm
                    </Button>
                )}
            </DialogFooter>
        </CustomModal>
    );
};

export default UpdateTransaction;
